// Blog content loader — markdown files only, no external CMS.
// Drop a .md file in src/content/blog/ and it is picked up automatically
// via webpack's require.context (no manifest or registry needed).

const blogContext = require.context('../content/blog', false, /\.md$/);

function parseFrontmatter(raw) {
  const match = /^---\r?\n([\s\S]*?)\r?\n---\r?\n?/.exec(raw);
  if (!match) {
    return { data: {}, body: raw };
  }

  const data = {};
  match[1].split(/\r?\n/).forEach((line) => {
    const sep = line.indexOf(':');
    if (sep === -1) return;
    const key = line.slice(0, sep).trim();
    let value = line.slice(sep + 1).trim();
    if (
      (value.startsWith('"') && value.endsWith('"')) ||
      (value.startsWith("'") && value.endsWith("'"))
    ) {
      value = value.slice(1, -1);
    }
    data[key] = value;
  });

  return { data, body: raw.slice(match[0].length) };
}

function postTimestamp(post) {
  const t = new Date(post.date).getTime();
  return Number.isNaN(t) ? -Infinity : t;
}

let postsCache = null;

export async function getAllPosts() {
  if (postsCache) return postsCache;

  const posts = await Promise.all(
    blogContext.keys().map(async (key) => {
      const slug = key.replace(/^\.\//, '').replace(/\.md$/, '');
      const mod = blogContext(key);
      const url = typeof mod === 'string' ? mod : mod.default;
      const raw = await (await fetch(url)).text();
      const { data, body } = parseFrontmatter(raw);
      return {
        slug,
        title: data.title || '',
        date: data.date || '',
        excerpt: data.excerpt || '',
        readTime: data.readTime || '',
        body,
      };
    })
  );

  // Newest first; posts without a valid date sink to the bottom
  posts.sort((a, b) => postTimestamp(b) - postTimestamp(a));

  postsCache = posts;
  return postsCache;
}

// Posts with an empty title are treated as unpublished drafts
// and hidden from the index (still reachable by direct URL).
export async function getPublishedPosts() {
  const posts = await getAllPosts();
  return posts.filter((post) => post.title);
}

export async function getPostBySlug(slug) {
  const posts = await getAllPosts();
  return posts.find((post) => post.slug === slug) || null;
}

export function formatPostDate(date) {
  if (!date) return '';
  const parsed = new Date(`${date}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) return date;
  return parsed.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
